// src/pages/CartPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "./CartPage.css";

export default function CartPage() {
  const { items, removeItem, updateQty, moveToWishlist, memberSavings, cartTotal, cartMRP } = useCart();
  const navigate = useNavigate();
  const [coupon, setCoupon] = useState("");
  const [couponOpen, setCouponOpen] = useState(false);
  const [voucherOpen, setVoucherOpen] = useState(false);
  const [tssMoneyOpen, setTssMoneyOpen] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);

  const selectedItems = items.filter(i => i.selected !== false);
  const selectedTotal = selectedItems.reduce((s, i) => s + i.price * i.qty, 0);
  const selectedMRP = selectedItems.reduce((s, i) => s + i.mrp * i.qty, 0);
  const memberSave = Math.round(selectedTotal * 0.09);
  const shipping = selectedTotal > 445 ? 0 : 50;
  const finalTotal = selectedTotal - memberSave + shipping;

  return (
    <div className="cart-page">
      {/* Checkout breadcrumb */}
      <div className="cart-breadcrumb">
        <span className="cart-breadcrumb__step cart-breadcrumb__step--active">MY BAG</span>
        <span className="cart-breadcrumb__line" />
        <span className="cart-breadcrumb__step">ADDRESS</span>
        <span className="cart-breadcrumb__line" />
        <span className="cart-breadcrumb__step">PAYMENT</span>
      </div>

      <div className="cart-layout container">
        {/* Left: Items */}
        <div className="cart-items">
          {/* Member savings banner */}
          {memberSave > 0 && (
            <div className="cart-member-banner">
              <span className="cart-member-banner__icon">%</span>
              <span><strong className="cart-member-banner__highlight">Member Savings</strong> on this order are ₹ {memberSave.toLocaleString()}</span>
            </div>
          )}

          {/* Items selected count */}
          {items.length > 0 && (
            <div className="cart-select-row">
              <input type="checkbox" defaultChecked id="select-all" onChange={() => {}} />
              <label htmlFor="select-all" style={{ fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
                {selectedItems.length}/{items.length} ITEMS SELECTED &nbsp;
                <span style={{ color: "var(--tss-teal)", fontWeight: 700 }}>
                  (₹ {selectedTotal.toLocaleString()})
                </span>
              </label>
              <div style={{ marginLeft: "auto", display: "flex", gap: 16 }}>
                <button className="cart-icon-btn" title="Move all to wishlist">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                  </svg>
                </button>
                <button className="cart-icon-btn cart-icon-btn--red" title="Remove selected" onClick={() => selectedItems.forEach(i => removeItem(i.key))}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                  </svg>
                </button>
              </div>
            </div>
          )}

          {/* Empty cart */}
          {items.length === 0 && (
            <div className="cart-empty">
              <div className="cart-empty__icon">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1.5">
                  <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
                  <path d="M16 10a4 4 0 0 1-8 0"/>
                </svg>
              </div>
              <h3>Your bag is empty</h3>
              <p>Looks like you haven't added anything yet</p>
              <button className="cart-empty__btn" onClick={() => navigate("/")}>CONTINUE SHOPPING</button>
            </div>
          )}

          {/* Cart item rows */}
          {items.map(item => (
            <CartItem key={item.key} item={item} onRemove={removeItem} onQty={updateQty} onWishlist={moveToWishlist} />
          ))}

          {/* Membership upsell */}
          <div className="cart-membership">
            <input type="checkbox" id="membership" />
            <label htmlFor="membership" className="cart-membership__label">
              <div className="cart-membership__logo">
                <svg viewBox="0 0 48 52" fill="none" width="32" height="36">
                  <ellipse cx="24" cy="20" rx="15" ry="16" fill="none" stroke="white" strokeWidth="2.5"/>
                  <circle cx="17" cy="15" r="3.5" fill="white"/>
                  <circle cx="31" cy="15" r="3.5" fill="white"/>
                  <path d="M17 25 Q24 31 31 25" stroke="white" strokeWidth="2" fill="none"/>
                  <path d="M9 36 L24 36 L39 36 L39 52 L30 46 L24 52 L18 46 L9 52 Z" fill="white"/>
                </svg>
              </div>
              <div>
                <p className="cart-membership__title">The Souled Store Membership</p>
                <p className="cart-membership__sub">12 months Membership</p>
              </div>
              <span className="cart-membership__price">₹ 199</span>
            </label>
          </div>
        </div>

        {/* Right: Billing sidebar */}
        <div className="cart-sidebar">
          {/* Coupon / Voucher / TSS Money */}
          <div className="cart-promo">
            <AccordionRow
              icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 12v10H4V12"/><path d="M22 7H2v5h20V7z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>}
              label="Apply Coupon"
              open={couponOpen}
              onToggle={() => setCouponOpen(!couponOpen)}
            >
              <div className="cart-coupon-row">
                <input className="cart-coupon-input" placeholder="Enter coupon code"
                  value={coupon} onChange={e => setCoupon(e.target.value.toUpperCase())} />
                <button className="cart-coupon-apply" onClick={() => { if (coupon) setCouponApplied(true); }}>
                  APPLY
                </button>
              </div>
              {couponApplied && <p style={{ color: "var(--tss-teal)", fontSize: 12, marginTop: 8 }}>✓ Coupon applied!</p>}
            </AccordionRow>

            <AccordionRow
              icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>}
              label="Gift Voucher"
              open={voucherOpen}
              onToggle={() => setVoucherOpen(!voucherOpen)}
            >
              <div className="cart-coupon-row">
                <input className="cart-coupon-input" placeholder="Enter voucher code" />
                <button className="cart-coupon-apply">APPLY</button>
              </div>
            </AccordionRow>

            <AccordionRow
              icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>}
              label="TSS Money / TSS Points"
              open={tssMoneyOpen}
              onToggle={() => setTssMoneyOpen(!tssMoneyOpen)}
            >
              <p style={{ fontSize: 13, color: "var(--tss-gray-500)", padding: "8px 0" }}>You have 0 TSS Points. Earn points on your purchases!</p>
            </AccordionRow>
          </div>

          {/* Billing details */}
          <div className="cart-billing">
            <h3 className="cart-billing__title">BILLING DETAILS</h3>
            <div className="cart-billing__row">
              <span>Cart Total <span style={{ fontWeight: 400, fontSize: 12, color: "var(--tss-gray-400)" }}>(Incl. of all taxes)</span></span>
              <span>₹ {selectedMRP.toLocaleString()}.00</span>
            </div>
            {memberSave > 0 && (
              <div className="cart-billing__row cart-billing__row--savings">
                <span>Member Savings</span>
                <span>- ₹ {memberSave.toLocaleString()}.00</span>
              </div>
            )}
            {couponApplied && (
              <div className="cart-billing__row" style={{ color: "var(--tss-teal)" }}>
                <span>Coupon Discount</span>
                <span>- ₹ 50.00</span>
              </div>
            )}
            <div className="cart-billing__row">
              <span>Shipping Charges</span>
              <span>{shipping === 0 ? <><span style={{ color: "var(--tss-teal)", fontWeight: 700 }}>Free</span> <s style={{ color: "var(--tss-gray-400)", fontSize: 12 }}>₹ 50.00</s></> : `₹ ${shipping}`}</span>
            </div>
            <div className="cart-billing__row cart-billing__row--total">
              <span>Total Amount <span style={{ fontWeight: 400, fontSize: 12 }}>(Incl. of GST)</span></span>
              <span>₹ {(finalTotal - (couponApplied ? 50 : 0)).toLocaleString()}.00</span>
            </div>
          </div>

          <button className="cart-place-order" onClick={() => items.length > 0 && navigate("/checkout/address")}>
            PLACE ORDER
          </button>
        </div>
      </div>
    </div>
  );
}

function CartItem({ item, onRemove, onQty, onWishlist }) {
  return (
    <div className="cart-item">
      <input type="checkbox" defaultChecked className="cart-item__check" />
      <img src={item.img} alt={item.name} className="cart-item__img" />
      <div className="cart-item__info">
        <p className="cart-item__name">{item.name}</p>
        <p className="cart-item__cat">{item.brand}</p>
        <div className="cart-item__controls">
          <select className="cart-item__select" value={item.selectedSize}>
            <option>Size: {item.selectedSize}</option>
          </select>
          <select className="cart-item__select"
            value={item.qty} onChange={e => onQty(item.key, +e.target.value)}>
            {[1,2,3,4,5].map(n => <option key={n} value={n}>Qty: {n}</option>)}
          </select>
        </div>
      </div>
      <div className="cart-item__price">
        <div>
          <span className="cart-item__sale">₹ {(item.price * item.qty).toLocaleString()}</span>
          {item.mrp > item.price && <s className="cart-item__original">₹ {(item.mrp * item.qty).toLocaleString()}</s>}
        </div>
        <p className="cart-item__taxes">MRP incl. of all taxes</p>
        <p className="cart-item__member-save">Member Savings: ₹ {Math.round((item.mrp - item.price) * item.qty * 0.1)}</p>
        <div className="cart-item__actions">
          <button onClick={() => onRemove(item.key)}>REMOVE</button>
          <button onClick={() => onWishlist(item.key)}>MOVE TO WISHLIST</button>
        </div>
      </div>
    </div>
  );
}

function AccordionRow({ icon, label, open, onToggle, children }) {
  return (
    <div className="accordion-row">
      <button className="accordion-row__btn" onClick={onToggle}>
        <span className="accordion-row__icon">{icon}</span>
        <span className="accordion-row__label">{label}</span>
        <svg className={`accordion-row__chevron ${open ? "accordion-row__chevron--open" : ""}`}
          width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>
      {open && <div className="accordion-row__body">{children}</div>}
    </div>
  );
}
